import { AsyncActionHandler } from 'action-handler';
import {
  markTileRemoved,
  markTileInstalled,
  setPendingTileInstalls
} from 'actions/registry';

export default new AsyncActionHandler({
  name: 'uninstall_tile',
  stateProp: 'uninstallTile',
  handler: (id) => async (dispatch) => {
    await dispatch(markTileRemoved(id));
    await dispatch(setPendingTileInstalls(id, false));

    let commsResponse;
    try {
      commsResponse = await window.__webview_comms__.trigger('tiles-refresh');
    } catch (_) {
      await dispatch(markTileInstalled(id, false));
    }

    const triggerSuccesfull = commsResponse
      ? commsResponse['tiles-refreshed-successfully']
      : false;

    if (triggerSuccesfull !== true) {
      await dispatch(markTileInstalled(id, false));
    }
  }
});
